<template>
  <v-col>
    <!-- Customers data table -->
    <customer-table
      :key="index"
      url-create="AddNewCustomer"
      url-api="/customer"
      :headers="headers"
    >
      <!-- Add customer -->
      <template v-slot:urlCreate="">
        <v-btn
          class="info"
          @click.prevent="
            $router.push({
              name: 'AddNewCustomer',
            })
          "
        >
          <v-icon>mdi-plus</v-icon>
          Add Customer
        </v-btn>
      </template>

      <!-- end -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <!-- Customer details -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'CustomerDetail',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-more
              </v-icon>
            </v-btn>
          </template>
          <span>More details</span>
        </v-tooltip>
        <!-- end -->

        <!-- Customer info edit -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'EditCustomer',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <!-- end -->

        <!-- Customer remove -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              @click="warningCustomerRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </customer-table>

    <!-- end data table -->

    <!-- Customer remove confirmation dialog  -->
    <v-dialog
      v-model="customerRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline red--text">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove customer?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="customerRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeCustomer"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import CustomersTable from "../common/DataTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    "customer-table": CustomersTable,
  },
  data() {
    return {
      customerRemoveWarning: false,
      customer: [],
      index: 1,
      headers: [
        {
          text: "Created At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "First Name",
          sortable: true,
          value: "firstName",
        },
        {
          text: "Last Name",
          sortable: false,
          value: "lastName",
        },
        {
          text: "Phone",
          sortable: true,
          value: "phone",
        },
        {
          text: "Email",
          sortable: true,
          value: "email",
        },
        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    removeCustomer() {
      window.axios
        .delete("/customer/" + this.$data.customer.id)
        .then((response) => {
          this.$data.customerRemoveWarning = false;
          this.$data.index++;
          this.feedback(response.data.message);
        });
    },
    warningCustomerRemove(customer) {
      this.$data.customer = customer;
      this.$data.customerRemoveWarning = true;
    },
  },
};
</script>
